import { NotifyHelper } from "../../../helpers/toast";
import { eHinhThucActionsObj } from "../../action-types/mien-giam/IHinhThucActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const hinhThucActions = {
  ...generateActions(eHinhThucActionsObj, "HINH_THUC_MIEN_GIAM"),
  ...generateActionForKey(
    eHinhThucActionsObj,
    "HINH_THUC_MIEN_GIAM",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eHinhThucActionsObj,
    "HINH_THUC_MIEN_GIAM",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHinhThucActionsObj,
    "HINH_THUC_MIEN_GIAM",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eHinhThucActionsObj,
    "HINH_THUC_MIEN_GIAM",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
